import * as React from 'react';
import { Input as InputPrimitive } from '@/features/ui/primitives/input';
import { cn } from '@/lib/utils';

const Input = React.forwardRef<
  React.ElementRef<typeof InputPrimitive>,
  React.ComponentPropsWithoutRef<typeof InputPrimitive>
>(({ className, ...props }, ref) => (
  <InputPrimitive
    ref={ref}
    className={cn(
      'h-9 focus:ring-2 focus:ring-blue-500 placeholder:text-placeholder-foreground', // Match height and focus ring from baseInputStyles
      className
    )}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
